module.exports = __webpack_public_path__ + "img/amc.0a3b25f3.png";